import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getOrders(context, lang, udid, datetimeFrom, datetimeTo) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { datetimeFrom, datetimeTo };
    return this.http.get(this.BASE_URL + 'private/v2.0/orders', options);
  }

  public getOrdersKPI(context, lang, udid, datetimeFrom, datetimeTo) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { datetimeFrom, datetimeTo };
    return this.http.get(this.BASE_URL + 'private/v2.0/orders/kpi', options);
  }
}
